const Role = {
  Admin: "Admin",
  User: "User",
};

export default Role;
